// plan-18 S03: commune generator — pure function f(question) → answer

import { fromString, mulberry32 } from '../../core/seed'
import { normalize, qStats } from './normalize'
import { qHash } from './seed'
import {
  OBSERVATION_POOL,
  INTERPRETATION_POOL,
  VERDICT_POOL,
  EMPTY_RESPONSE,
} from './pools'

export interface CommuneResult {
  question: string
  qHash: string
  lines: [string, string, string]
}

function interpolate(template: string, stats: ReturnType<typeof qStats>, shortHash: string): string {
  return template
    .replace(/\$\{qHashShort\}/g, shortHash)
    .replace(/\$\{qDigits\}/g, String(stats.digits))
    .replace(/\$\{qWords\}/g, String(stats.words))
    .replace(/\$\{qLen\}/g, String(stats.len))
    .replace(/\$\{qFirstWord\}/g, stats.firstWord)
}

export function commune(question: string): CommuneResult {
  const normalized = normalize(question)

  if (!normalized) {
    return {
      question: '',
      qHash: '',
      lines: EMPTY_RESPONSE,
    }
  }

  const hash = qHash(question)
  const shortHash = hash.slice(0, 4)
  const seed = fromString(normalized)
  const rng = mulberry32(seed)

  const obsIdx = Math.floor(rng() * OBSERVATION_POOL.length)
  const intIdx = Math.floor(rng() * INTERPRETATION_POOL.length)
  const verIdx = Math.floor(rng() * VERDICT_POOL.length)

  const stats = qStats(normalized)

  const lines: [string, string, string] = [
    '> ' + interpolate(OBSERVATION_POOL[obsIdx], stats, shortHash),
    '> ' + interpolate(INTERPRETATION_POOL[intIdx], stats, shortHash),
    '> ' + interpolate(VERDICT_POOL[verIdx], stats, shortHash),
  ]

  return {
    question: normalized,
    qHash: hash,
    lines,
  }
}
